import type { IdentityPayload } from 'types';

interface State extends DeepPartial<IdentityPayload> {
  step: 1 | 2;
}
const initialState: State = {
  step: 1,
};

type Action =
  | {
      type: 'UPDATE_LOGIN_IDENTITY';
      payload: Pick<typeof initialState, 'phoneNumber' | 'ticket'>;
    }
  | {
      type: 'UPDATE_LOGIN_STEP';
      payload: Pick<typeof initialState, 'step'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
